import './axios'
import './quasar'
import './tour'
import './maps'


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/index.js